import {PossibleValueInput} from 'src/modules/event-create/attributes-block/typedefs';

export const getPossibleValues = (
    possibleValueInputs: PossibleValueInput[],
): string[] => (
    possibleValueInputs
        .filter(({isEmptySlot}) => !isEmptySlot)
        .map(({value}) => value)
);
